var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export function LinePattern(props) {
    return (React.createElement("svg", __assign({ width: "216", height: "216", viewBox: "0 0 216 216", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("mask", { id: "mask0_4947_380564", style: { maskType: "alpha" }, maskUnits: "userSpaceOnUse", x: "-120", y: "-120", width: "336", height: "336" },
            React.createElement("circle", { cx: "48", cy: "48", r: "167.5", fill: "url('#paint0_radial_4947_380564')" })),
        React.createElement("g", { mask: "url(#mask0_4947_380564)" },
            React.createElement("circle", { cx: "48", cy: "48", r: "47.5", className: 'stroke-gray-200' }),
            React.createElement("circle", { cx: "48", cy: "48", r: "47.5", className: 'stroke-gray-200' }),
            React.createElement("circle", { cx: "48", cy: "48", r: "71.5", className: 'stroke-gray-200' }),
            React.createElement("circle", { cx: "48", cy: "48", r: "95.5", className: 'stroke-gray-200' }),
            React.createElement("circle", { cx: "48", cy: "48", r: "119.5", className: 'stroke-gray-200' }),
            React.createElement("circle", { cx: "48", cy: "48", r: "143.5", className: 'stroke-gray-200' }),
            React.createElement("circle", { cx: "48", cy: "48", r: "167.5", className: 'stroke-gray-200' })),
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "paint0_radial_4947_380564", cx: "48", cy: "48", r: "168", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", null),
                React.createElement("stop", { offset: "1", stopOpacity: "0" })))));
}
